// Excel、CSV文件的mime type
export const EXCEL_CSV_MIMETYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

// 下载预估时间时，最大预估下载数量 100000条数据
export const CALCULATE_DOWNLOAD_MAXIMUM_COUNT = 10 * 10000;
